import Shop from './Shop.view';

export default Shop;
